<template>
  <div class="certificates">
    <app-header/>

    <div class="container certificates-page">
      <div class="row justify-content-center">
        <div class="col-xl-10">
          <div class="row">
            <div
              class="col-md-6 col-lg-4 certificates-page-card"
              v-for="(certificate, index) in certificates"
              :key="index"
            >
              <div class="certificates-page-card__img-wrap" @click="openPhotoSwipe(index)">
                <div
                  class="certificates-page-card__img"
                  :style="{backgroundImage: 'url(' + certificate.smallImg + ')'}"
                ></div>
              </div>
              <div class="certificates-page-card__footer">
                <a
                  class="certificates-page-card__link"
                  :href="certificate.filename"
                  target="_blank"
                >
                  <span class="certificates-page-card__link-title">Скачать файл</span>
                  <span class="certificates-page-card__link-icon"></span>
                </a>
                <div class="certificates-page-card__plus-icon"></div>
              </div>
            </div>
            <!-- end certificates-page-card -->
          </div>
          <!-- end row -->
        </div>
      </div>
      <!-- end row -->
    </div>

    <!-- Root element of PhotoSwipe. Must have class pswp. -->
    <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
      <!-- Background of PhotoSwipe. 
      It's a separate element as animating opacity is faster than rgba().-->
      <div class="pswp__bg"></div>

      <!-- Slides wrapper with overflow:hidden. -->
      <div class="pswp__scroll-wrap">
        <!-- Container that holds slides. 
                PhotoSwipe keeps only 3 of them in the DOM to save memory.
        Don't modify these 3 pswp__item elements, data is added later on.-->
        <div class="pswp__container">
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
        </div>

        <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
        <div class="pswp__ui pswp__ui--hidden">
          <div class="pswp__top-bar">
            <!--  Controls are self-explanatory. Order can be changed. -->
            <div class="pswp__counter"></div>

            <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
            
            <button class="pswp__button pswp__button--share" title="Share"></button>
            
            <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
            
            <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

            <!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR -->
            <!-- element will get class pswp__preloader--active when preloader is running -->
            <div class="pswp__preloader">
              <div class="pswp__preloader__icn">
                <div class="pswp__preloader__cut">
                  <div class="pswp__preloader__donut"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
            <div class="pswp__share-tooltip"></div>
          </div>

          <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
          
          <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>

          <div class="pswp__caption">
            <div class="pswp__caption__center"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import { mapGetters } from "vuex";

import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
import PhotoSwipe from "photoswipe/dist/photoswipe.min.js";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default.min.js";

export default {
  name: "home",
  components: {
    "app-header": Header
  },
  metaInfo() {
    return {
      title: "Сертификаты",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "ТОО СК-Грант реализует щебень фракционный (радиоактивность 1 класса, качество 1 класса) ГОСТ 8267-93, из карьера «Золоторунный» (Тайыншинский район, Северо-Казахстанская область)."
        },
        {
          property: "og:title",
          content: "Сертификаты - TOO СК-Грант",
          vmid: "og:title"
        },
        {
          property: "og:description",
          content:
            "ТОО СК-Грант реализует щебень фракционный (радиоактивность 1 класса, качество 1 класса) ГОСТ 8267-93, из карьера «Золоторунный» (Тайыншинский район, Северо-Казахстанская область).",
          vmid: "og:description"
        }
      ]
    };
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("certificates", ["certificates"])
  },
  mounted() {},
  methods: {
    openPhotoSwipe(i) {
      let pswpElement = document.querySelectorAll(".pswp")[0];

      let items = this.certificates.map(item => {
        return {
          src: item.largeImg,
          w: 1654,
          h: 2339
        };
      });

      let options = {
        history: false,
        focus: false,
        index: i,
        showAnimationDuration: 0,
        hideAnimationDuration: 0,
        shareEl: false,
        bgOpacity: 0.8
      };

      let gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        items,
        options
      );
      gallery.init();
    }
  }
};
</script>
